import Vue from 'vue';
import {AuthService} from "@/service/auth";

const state = {};

const getters = {};

const actions = {

    login(ctx, data) {
        return AuthService.getBareToken().then(res => AuthService.login(data, res.data.token));
    },

    get_user() {
        return AuthService.get_user();
    },

    social_received(ctx, data) {
        return AuthService.getBareToken().then(res => AuthService.social_login(data, res.data.token));
    },

    social(ctx, type) {
        Vue.auth.oauth2(type, {
            body: {},
            code: false,
            params: {
                state: {
                    remember: false,
                    staySignedIn: true,
                    fetchUser: false,
                }
            }
        })
    },

    register(ctx, form) {
        return AuthService.getBareToken().then(res => AuthService.register(form, res.data.token));
    },

    resend_email(ctx, email) {
        return AuthService.getBareToken().then(res => AuthService.resend_email(email, res.data.token));
    },

    reset(ctx, email) {
        return AuthService.getBareToken().then(res => AuthService.reset_email(email, res.data.token))
    },

    check_reset_token(ctx, token) {
        return AuthService.check_reset_token(token);
    },

    set_new_password(ctx, params) {
        return AuthService.getBareToken().then(res => AuthService.set_new_password(params, res.data.token));
    },

    logout() {
        return new Promise((resolve, reject) => {
            Vue.auth.logout().then((res) => {
                Vue.router.push({
                    name: 'Login'
                });

                resolve(res);
            }, reject);
        });
    },
};

const mutations = {};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};